export default "__VITE_PUBLIC_ASSET__f87dbe22__"